import firebase from "./firebase";
import store from "store";
import validator from "validator";
import _ from "lodash";
import URL from "url-parse";
import moment from "moment";

const expirePlugin = require("store/plugins/expire");
store.addPlugin(expirePlugin);

export const Title = "GUARENTEE";
export const CanonicalURI = "https://guarentee.com";

// export const PrimaryColor = "rgba(48,48,48,1)";
export const PrimaryColor = "rgba(78,68,228,1)";
document.documentElement.style.setProperty("--primary-color", PrimaryColor);
// export const SecondaryColor = "rgba(0, 132, 137, 1)";
export const SecondaryColor = "rgba(78,68,228,1)";
document.documentElement.style.setProperty("--secondary-color", SecondaryColor);
// export const AccentColor = "rgba(255, 90, 95, 1)";
export const AccentColor = "rgba(78,68,228,1)";
document.documentElement.style.setProperty("--accent-color", AccentColor);
// export const TertiaryColor = "rgba(255, 90, 95, 1)";
export const TertiaryColor = "rgba(255, 90, 95, 1)";
document.documentElement.style.setProperty("--tertiary-color", TertiaryColor);
// export const WhiteColor = "rgba(255,255,255,1)";
export const WhiteColor = "rgba(255,255,255,1)";
document.documentElement.style.setProperty("--white-color", WhiteColor);
// export const BGColor = "rgba(255,255,255,1)";
export const BGColor = "rgba(255,255,255,1)";
document.documentElement.style.setProperty("--bg-color", BGColor);
// export const BlackColor = "rgba(5,5,5,1)";
export const BlackColor = "rgba(5,5,5,1)";
document.documentElement.style.setProperty("--black-color", BlackColor);
// export const BorderCOlor = "rgba(228, 228, 228, 1)"
export const BorderCOlor = "rgba(228, 228, 228, 1)";
document.documentElement.style.setProperty("--border-color", BorderCOlor);
// export const PrimaryOpaqueColor = "rgba(30,46,78, 1)"
export const PrimaryOpaqueColor = "rgba(30,46,78, 1)";
document.documentElement.style.setProperty(
  "--primary-opaque-color",
  PrimaryOpaqueColor
);
// export const GreyOpaqueColor = "rgba(225, 225, 225, 0.33)"
export const GreyOpaqueColor = "rgba(225, 225, 225, 0.33)";
document.documentElement.style.setProperty(
  "--grey-opaque-color",
  GreyOpaqueColor
);
// export const GreyColor = "rgba(136,136,136,1)"
export const GreyColor = "rgba(136,136,136,1)";
document.documentElement.style.setProperty("--grey-color", GreyColor);

export const UpdateFav = (uid, lid, add) => {
  return new Promise((resolve, reject) => {
    const update = {
      [`favs.${lid}`]: !!add
        ? Date.now()
        : firebase.firestore.FieldValue.delete()
    };
    firebase
      .firestore()
      .collection("my")
      .doc(uid)
      .update(update)
      .then(() => resolve(!!add ? "Favourited!" : "Removed!"))
      .catch(error => reject(error));
  });
};

export const TranslateListing = listing => {
  return new Promise((resolve, reject) => {
    if (!listing) reject("No Listing");
    Object.keys(listing).forEach(key => {
      const newKey = Dictionary[key];
      if (!newKey) return;
      listing[newKey] = listing[key];
      if (newKey === "expense") {
        const expense = listing.expense;
        Object.keys(expense).forEach(key => {
          const newKey = ExpenseDictionary[key];
          expense[newKey] = expense[key];
          delete expense[key];
        });
      }
      if (newKey === "location") {
        const location = listing.location;
        Object.keys(location).forEach(key => {
          const newKey = LocationDictionary[key];
          location[newKey] = location[key];
          delete location[key];
        });
      }
      if (newKey === "physicalProperties") {
        const physicalProperties = listing.physicalProperties;
        Object.keys(physicalProperties).forEach(key => {
          const newKey = PhysicalPropertiesDictionary[key];
          physicalProperties[newKey] = physicalProperties[key];
          delete physicalProperties[key];
        });
      }
      if (newKey === "parking") {
        const parking = listing.parking;
        Object.keys(parking).forEach(key => {
          const newKey = ParkingDictionary[key];
          parking[newKey] = parking[key];
          delete parking[key];
        });
      }
      delete listing[key];
    });
    resolve(listing);
  });
};

export const MakeSearchUrl = value => {
  return `${
    !!value.minexpense || value.minexpense === 0
      ? `minexpense=${value.minexpense}&`
      : ""
  }${
    !!value.maxexpense || value.maxexpense === 0
      ? `maxexpense=${value.maxexpense}&`
      : ""
  }${!!value.beds || value.beds === 0 ? `beds=${value.beds}&` : ""}${
    !!value.baths || value.baths === 0 ? `baths=${value.baths}&` : ""
  }${
    !!value.parking || value.parking === 0 ? `parking=${value.parking}&` : ""
  }${!!value.furnished ? `furnished=${value.furnished}&` : ""}`;
};

export const ResubmitApplication = uid => {
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("application")
      .doc(uid)
      .update({
        status: firebase.firestore.FieldValue.delete(),
        updated: firebase.firestore.Timestamp.now()
      })
      .then(() => resolve())
      .catch(error => reject(error));
  });
};

export const GetApplicationStatus = user => {
  return [
    user.creditReport,
    user.currentEmployment,
    user.displayName,
    user.employmentLetter,
    user.phoneNumber,
    user.photoId,
    user.previousEmployment
  ].every(e => e)
    ? true
    : false;
  // if (
  // ) {
  //   return true;
  // } else {
  //   return false
  // }
};

export const RequiredProfile = {
  // addresses: "history",
  creditReport: "docs",
  currentEmployment: "history",
  displayName: "profile",
  employmentLetter: "docs",
  phoneNumber: "profile",
  photoId: "docs"
  // previousEmployment: "history"
  // references: "references"
};

export const SearchParams = {
  beds: "number",
  baths: "number",
  parking: "number",
  minexpense: "number",
  maxexpense: "number",
  furnished: "boolean"
};

export const ProfileDictionary = {
  creditReport: "credit report",
  currentEmployment: "current employment",
  displayName: "display name",
  employmentLetter: "employment letter",
  phoneNumber: "phone number",
  photoId: "photo ID"
};

export const Dictionary = {
  Amenities: "amenities",
  Description: "description",
  Expense: "expense",
  Extras: "extras",
  Furnished: "furnished",
  Guarentee_Score: "guarenteeScore",
  Included_Expenses: "includedExpenses",
  Listing_Date: "listingDate",
  Listing_ID: "lid",
  Location: "location",
  Location_Score: "locationScore",
  Locker: "locker",
  Rooms: "rooms",
  Parking: "parking",
  Pets_Allowed: "petsAllowed",
  Physical_Properties: "physicalProperties",
  Preview: "preview",
  Private_Entrance: "privateEntrance",
  Realty: "realty",
  Title: "title",
  price_Score: "priceScore"
};

const ExpenseDictionary = {
  Currency: "currency",
  Rent_Expense: "rentExpense",
  Term: "term"
};

export const LocationDictionary = {
  Area: "area",
  City: "city",
  Country: "country",
  Geo: "geo",
  Geopoint: "geopoint",
  Lat: "lat",
  Lng: "lng",
  Major_Intersection: "majorIntersection",
  Postal_Code: "postalCode",
  Province: "province",
  Street_Name: "streetName",
  Street_Number_Text: "streetNumberText",
  Unit: "unit"
};

export const ParkingDictionary = {
  Garage_Parking: "garageParking",
  Parking_Cost: "parkingCost",
  Parking_Included: "parkingIncluded",
  TotalParking: "totalParking"
};

export const PhysicalPropertiesDictionary = {
  Baths: "baths",
  Beds: "beds",
  Facing_Direction: "facingDirection",
  Footage: "footage",
  Footage_Cat: "footageCat",
  Half_Beds: "halfBeds"
};

export const APPLICATION_STATUSES = {
  _EVALUATING: "evaluating",
  _INCOMPLETE: "incomplete",
  _PENDING_SIGNATURE: "pending_signature",
  _APPLIED: "applied",
  _SUBMITTED: "submitted",
  _ACCEPTED: "accepted",
  _DECLINED: "declined"
};

export const LOZENGE_STATUSES = {
  inactive: "moved",
  evaluating: "default",
  incomplete: "moved",
  pending_signature: "inprogress",
  applied: "new",
  submitted: "new",
  accepted: "success",
  declined: "removed"
};

export const APPLICATION_MESSAGES = {
  inactive: {
    title: "Inactive Application",
    message:
      "You may only submit one application at a time. You currently have another application active that has been submitted. To mark that application inactive and submit this application instead, please submit this application below.",
    appearance: "info"
  },
  evaluating: {
    title: "Evaluating Application",
    message:
      "Your application is being evaluated for completeness. Hang tight.",
    appearance: "change"
  },
  incomplete: {
    title: "Incomplete Application",
    message:
      "Your application is incomplete. Please complete your profile and resubmit it.",
    appearance: "warning"
  },
  pending_signature: {
    title: "Signature Page Emailed",
    message:
      "Great. Your application is complete and a signature page has been emailed to you. Please check your email and sign it.",
    appearance: "info"
  },
  applied: {
    title: "Applied",
    message:
      "Great. Your application has been received and you will be contacted by an agent very shortly.",
    appearance: "confirmation"
  },
  submitted: {
    title: "Application Submitted",
    message:
      "Great. Your application has been submitted and is being handled by an agent.",
    appearance: "confirmation"
  },
  accepted: {
    title: "Application Accepted",
    message: "Great! Your application has been accepted.",
    appearance: "confirmation"
  },
  declined: {
    title: "Application Declined",
    message: "Unfortunately your application has been declined",
    appearance: "error"
  }
};

export const GetApplication = uid => {
  return new Promise((resolve, reject) => {
    if (!uid) {
      reject("uid missing");
    }
    firebase
      .firestore()
      .collection("application")
      .doc(uid)
      .get()
      .then(documentSnapshot => resolve(documentSnapshot.data()))
      .catch(error => reject(error));
  });
};

export const GetUser = uid => {
  return new Promise((resolve, reject) => {
    if (!uid) {
      reject("uid missing");
    }
    firebase
      .firestore()
      .collection("my")
      .doc(uid)
      .get()
      .then(documentSnapshot => resolve(documentSnapshot.data()))
      .catch(error => reject(error));
  });
};

export const GetParam = (item, props) => {
  const match = props.match || {};
  const params = match.params || {};
  const param = params[item] || "";
  return param;
};

export const Login = email => {
  return new Promise((resolve, reject) => {
    var actionCodeSettings = {
      url: window.location.href,
      handleCodeInApp: true
    };
    firebase
      .auth()
      .sendSignInLinkToEmail(email, actionCodeSettings)
      .then(() => {
        store.set("emailForSignIn", email);
        const url = window.location.href;
        console.log(url);
        const parsed = new URL(url);
        console.log(parsed);
        const pathname = parsed.pathname;
        console.log(pathname);
        const query = parsed.query;
        console.log(query);
        const continueUrl = pathname + query;
        console.log(continueUrl);
        store.set("continueUrl", continueUrl);
        resolve("Login Email Sent");
      })
      .catch(err => reject(err));
  });
};

export const Logout = () => {
  return new Promise((resolve, reject) => {
    resolve(firebase.auth().signOut());
  });
};

export const setCache = (lid, data, name) => {
  return new Promise((resolve, reject) => {
    const cachedItems = store.get(name) || {};
    cachedItems[lid] = data;
    try {
      const expiration = moment()
        .add(2, "days")
        .toDate();
      store.set(name, cachedItems, expiration);
      resolve(cachedItems);
    } catch (error) {
      resolve(cachedItems);
      // reject(error);
    }
  });
};

// export const MakeTitle = listing => {
//   const location = listing.location || {};
//   return `${location.streetNumberText || ""} ${location.streetName || ""}`;
// };

export const GetRoomDimensions = room => {
  const rooms = room.split("x");

  const one = rooms[0] || "";
  const feetOne = one.split("'")[0] || "";
  const inchesOne = one.split("'")[1] || "";
  const formattedInchesOne = inchesOne.substring(1, 3);

  const two = rooms[1] || "";
  const feetTwo = two.split("'")[0] || "";
  const inchesTwo = two.split("'")[1] || "";
  const formattedInchesTwo = inchesTwo.substring(1, 3);

  return `${feetOne}${formattedInchesOne} x ${feetTwo}${formattedInchesTwo}`;
};

export const GetDateFromSeconds = timestamp =>
  moment.unix(timestamp).format("YYYY-MM-DD");

export const GetDateFromMilliseconds = timestamp =>
  moment(timestamp).format("YYYY-MM-DD");

export const GetTimestampFromDate = (date, format) =>
  moment(date, format).valueOf();

export const GetPhotos = lid => {
  return new Promise((resolve, reject) => {
    const cachedPhotos = store.get("photos") || {};
    if (!lid) {
      return reject("lid missing");
    }
    if (cachedPhotos[lid]) {
      console.log(`photos: ${lid} already exists `);
      resolve(cachedPhotos);
    } else {
      console.log("dont have photos yet for ", lid);
      firebase
        .firestore()
        .collection("photos")
        .doc(lid)
        .get()
        .then(snap => {
          const photos = snap.exists ? snap.data() : {};
          return photos;
        })
        .then(photos => setCache(lid, photos, "photos"))
        .then(cachedPhotos => resolve(cachedPhotos))
        .catch(error => console.log(error));
    }
  });
};

export const GetLocation = () => {
  return new Promise((resolve, reject) => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(position => {
        resolve(position);
      });
    } else {
      reject("Location Not Available");
    }
  });
};

export const GetListings = lid => {
  return new Promise((resolve, reject) => {
    const cachedListings = store.get("listings") || {};
    if (!lid) {
      return reject("lid missing");
    }
    if (cachedListings[lid]) {
      console.log(`lid: ${lid} already exists `);
      resolve(cachedListings);
    } else {
      const listing = firebase.functions().httpsCallable("listing");
      // const url = `https://us-central1-guarentee-app.cloudfunctions.net/api/listing/${lid}`;
      // fetch(url)
      //   .then(response => response.json())
      listing({ lid })
        .then(result => result.data)
        .then(data => setCache(lid, data.listing, "listings"))
        .then(cachedListings => resolve(cachedListings))
        .catch(error => console.log(error));
    }
  });
};

export const GetToken = () => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .currentUser.getIdTokenResult()
      .then(idTokenResult => resolve(idTokenResult))
      .catch(error => reject(error));
  });
};

export const isMinTenDigits = item => item.length > 9;
export const isValidUrl = item =>
  validator.isURL(item, { require_host: false });
export const isValidNumber = item =>
  validator.isNumeric(item + "", { no_symbols: false });
export const isValidEmail = item => validator.isEmail(item);
export const isValidDate = item => _.isDate(item);
export const isString = string => _.isString(string);



// WEBPACK FOOTER //
// ./src/utils/consts.js